import { DefaultSeoProps } from "next-seo";

export const defaultSEO: DefaultSeoProps = {
  titleTemplate: "%s | Uptime Monitor",
  defaultTitle: "Uptime Monitoring - 10-Second Checks with PagerDuty & Slack Integration",
  description:
    "Professional uptime monitoring with 10-second checks from 16 regions. Seamless integration with PagerDuty, Opsgenie, Slack, and your incident management tools. Free plan available.",
  canonical: "https://uptime-monitor.io",
  openGraph: {
    type: "website",
    locale: "en_US",
    url: "https://uptime-monitor.io",
    siteName: "Uptime Monitor",
    images: [
      {
        url: "https://uptime-monitor.io/android-chrome-512x512.png",
        width: 512,
        height: 512,
        alt: "Uptime Monitor Logo",
      },
    ],
  },
  additionalMetaTags: [
    {
      name: "robots",
      content: "index,follow",
    },
    {
      name: "application-name",
      content: "Uptime Monitor",
    },
  ],
  additionalLinkTags: [
    {
      rel: "icon",
      href: "/favicon.ico",
    },
    {
      rel: "apple-touch-icon",
      href: "/apple-touch-icon.png",
      sizes: "180x180",
    },
    {
      rel: "manifest",
      href: "/site.webmanifest",
    },
  ],
};
